import { render, staticRenderFns } from "./RequirementAddEditProposedActions.vue?vue&type=template&id=116a38f5"
import script from "./RequirementAddEditProposedActions.vue?vue&type=script&lang=js"
export * from "./RequirementAddEditProposedActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports